import styled from '@emotion/styled';
import {
  FALLBACK_COLOR,
  BODY_COLOR_OPACITY,
  BANNER_OPACITY,
} from '@/components/DesignSystem/ModernTheme/utils/common';
export const HeroBannerParent = styled.div`
  &.bg_type_video {
    background: ${(props) => props?.themeBackground};
    background-size: cover;
    background-position: center;
  }

  &.bg_type_image {
    background: ${(props) => props?.themeBackground};
    background-size: cover;
    background-position: center;
    & > .bg {
      position: absolute;
      height: 100%;
      object-fit: fill;
      width: 100%;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 0; /* Set the z-index behind other content */
    }
    /* Add a linear gradient overlay */
    &::after {
      content: '';
      background: ${(props) => props?.themeBackground};
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: ${BANNER_OPACITY};
      z-index: 1;
    }
  }

  &.bg_type_solid {
    background: ${(props) => props?.themeBackground};
  }
  &.bg_type_image::after,
  .bg_type_solid {
    content: '';
    background: ${(props) => props?.themeBackground};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: ${BANNER_OPACITY};
    z-index: 1;
  }
`;
export const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: 768px) {
    padding: 0;
  }
  @media screen and (max-width: 767px) {
    padding: 2rem 0 0 0;
    flex-direction: column;
    gap: 1.438rem;
  }
`;
export const TopSection = styled.div`
  display: flex;
  width: 100%;
  z-index: 99;
  @media screen and (min-width: 768px) {
    padding: 4.75rem 8.25rem;
    gap: 4.75rem;
  }
  @media screen and (max-width: 767px) {
    padding: 0 1.5rem;
    flex-direction: column;
    gap: 0.75rem;
  }
`;
export const LeftContainer = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;

  & > h1 {
    display: flex;
    flex-wrap: wrap;
    align-self: flex-start;
    color: ${(props) => props?.textStyles?.heading?.color};
    font-family: ${(props) => props?.textStyles?.heading?.fontFamily || 'Arial'};
    text-align: ${(props) => props?.textStyles?.heading?.textAlign || 'left'};
    margin: 0;
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  @media screen and (min-width: 768px) {
    width: 50%;
    & > h1 {
      font-size: ${(props) => props?.textStyles?.heading?.fontSize || '4.5rem'};
      font-weight: ${(props) => props?.textStyles?.heading?.fontWeight || '500'};
      line-height: 3.938rem;
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    & > h1 {
      font-size: 2rem;
      font-weight: 600;
      line-height: normal;
    }
  }
`;
export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.563rem;

  & > p {
    font-style: normal;
    color: ${(props) => props?.textStyles?.body?.color};
    text-align: ${(props) => props?.textStyles?.body?.textAlign || 'left'};
    font-family: ${(props) => props?.textStyles?.body?.fontFamily || 'Arial'};
    margin: 0;
    opacity: ${BODY_COLOR_OPACITY};
    display: flex;
    flex-wrap: wrap;
    align-self: flex-start;
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  @media screen and (min-width: 768px) {
    width: 50%;
    & > p {
      font-size: ${(props) => props?.textStyles?.body?.fontSize || '1.5rem'};
      font-weight: ${(props) => props?.textStyles?.body?.fontWeight || '400'};
      line-height: 1.75rem;
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    & > p {
      font-size: 0.875rem;
      font-weight: 400;
      line-height: normal;
    }
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  align-self: flex-start;
  flex-wrap: wrap;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    width: 100%;
    button {
      width: 100%;
    }
  }
`;
export const BottomSectionBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 16/9;
  width: 100%;
  z-index: 99;
  background-color: ${(props) => (props?.IS_MEDIA_URL ? 'transparent' : FALLBACK_COLOR)};

  & > .slider__parent,
  & > .slider__parent > .slick-slider,
  & > .slider__parent > .slick-slider > .slick-list,
  & > .slider__parent > .slick-slider > .slick-list > .slick-track,
  & > .slider__parent > .slick-slider > .slick-list > .slick-track > .slick-slide,
  & > .slider__parent > .slick-slider > .slick-list > .slick-track > .slick-slide > div,
  &
    > .slider__parent
    > .slick-slider
    > .slick-list
    > .slick-track
    > .slick-slide
    > div
    > .slider-media,
  &
    > .slider__parent
    > .slick-slider
    > .slick-list
    > .slick-track
    > .slick-slide
    > div
    > .slider-media
    > .slide-image-container,
  &
    > .slider__parent
    > .slick-slider
    > .slick-list
    > .slick-track
    > .slick-slide
    > div
    > .slider-media
    > .slide-image-container
    > img {
    height: 100% !important;
  }
  & > .slider__parent > .slick-slider > .slick-dots {
    display: none !important;
  }
  & > .video-container {
    height: 100%;
  }
`;
